import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import { Form } from 'antd';
import Widget from '../../Helpers/Widget';

const DashboardProvider = (props) => {
  const api = new API();
  const [mcqofthedayQuestion, setMcqofthedayQuestion] = useState({});
  const [mcqofthedayQuestionLoader, setMcqofthedayQuestionLoader] = useState(false);
  const [verticalUpdateLoader, setVerticalUpdateLoader] = useState(false);
  const [verticalVersionUpdateLoader, setVerticalVersionUpdateLoader] = useState(false);
  const [verticalGetLoader, setVerticalGetLoader] = useState(false);
  const [verticalVersionGetLoader, setVerticalVersionGetLoader] = useState(false);
  const [verticalForm] = Form.useForm();
  const [verticalVersionForm] = Form.useForm();
  const [verticalSingleData, setVerticalSingleData] = useState({});
  const [verticalVersionSingleData, setVerticalVersionSingleData] = useState({});
  const [currentCats, setCurrentCats] = useState({});
  const [getPatchContentList, setGetPatchContentList] = useState([]);
  const [getPatchContentListLoader, setGetPatchContentListLoader] = useState(false);
  const [patchUploadPopupVisible, setPatchUploadPopupVisible] = useState(false);
  const [patchUploadType, setPatchUploadType] = useState("");
  const [patchUploadFile, setPatchUploadFile] = useState(null);
  const [updatePatchContentList, setUpdatePatchContentList] = useState([]);
  const [updatePatchContentListLoader, setUpdatePatchContentListLoader] = useState(false);
  const fetchMcqofthedayQuestion = async (data) => {
    setMcqofthedayQuestionLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("examsnew/getmcqquestion", data, (err, res) => {
        if (res?.data?.status === 200) {
          setMcqofthedayQuestion(res?.data?.data);
        } else {
          setMcqofthedayQuestion({});
        }
        setMcqofthedayQuestionLoader(false);
      }));
  }
  const fetchVertical = async (data) => {
    setVerticalGetLoader(true);
    setCurrentCats(data);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("verical_banner", data, (err, res) => {
        if (res?.data?.status === 200) {
          verticalForm.setFieldsValue(res?.data?.data);
          setVerticalSingleData(res?.data?.data);
        } else {
          
          verticalForm.resetFields();
          setVerticalSingleData({});
        }
        setVerticalGetLoader(false);
      }));
  }

  const fetchVerticalVersion = async (data) => {
    setVerticalVersionGetLoader(true);
    setCurrentCats(data);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("verical_banner/version", data, (err, res) => {
        if (res?.data?.status === 200) {
          verticalVersionForm.setFieldsValue(res?.data?.data);
          setVerticalVersionSingleData(res?.data?.data);
        } else {
          
          verticalVersionForm.resetFields();
          setVerticalVersionSingleData({});
        }
        setVerticalVersionGetLoader(false);
      }));
  }

  const fetchVerticalUpdate = async (data) => {
    if(!currentCats?.category_id || !currentCats?.subcategory_id) {
      Widget.showMessage("error", "Please select category and subcategory");
      return;
    }
    setVerticalUpdateLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("verical_banner", {
        ...data,
        category_id:currentCats?.category_id,
        subcategory_id:currentCats?.subcategory_id
      }, (err, res) => {
        if (res?.data?.status === 200) {
          verticalForm.setFieldsValue(res?.data?.data);
          setVerticalSingleData(res?.data?.data);
          Widget.showMessage("success", res?.data?.message);
        } else {
          setVerticalSingleData({});
        }
        setVerticalUpdateLoader(false);
      }));
  }

  const fetchVerticalVersionUpdate = async (data) => {
    if(!currentCats?.category_id || !currentCats?.subcategory_id) {
      Widget.showMessage("error", "Please select category and subcategory");
      return;
    }
    setVerticalVersionUpdateLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("verical_banner/version", {
        ...data,
        category_id:currentCats?.category_id,
        subcategory_id:currentCats?.subcategory_id
      }, (err, res) => {
        if (res?.data?.status === 200) {
          verticalForm.setFieldsValue(res?.data?.data);
          setVerticalVersionSingleData(res?.data?.data);
          Widget.showMessage("success", res?.data?.message);
        } else {
          setVerticalVersionSingleData({});
        }
        setVerticalVersionUpdateLoader(false);
      }));
  }
  const fetchPatchContent = async (data) => {
    setGetPatchContentListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("contentpatch/list", {
        ...data,
      }, (err, res) => {
        if (res?.data?.status === 200) {
          verticalForm.setFieldsValue(res?.data?.data);
          setGetPatchContentList(res?.data?.data);
          Widget.showMessage("success", res?.data?.message);
        } else {
          setGetPatchContentList({});
        }
        setGetPatchContentListLoader(false);
      }));
  }

  const updatePatchContent = async () => {
    if(!patchUploadType || !patchUploadFile) {
      Widget.showMessage("error", "Please select patch type and file to upload");
      return;
    }
    let data = new FormData();
    data.append("type", patchUploadType);
    data.append("file", patchUploadFile);
    setUpdatePatchContentListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("contentpatch/updatelist", data, (err, res) => {
        if (res?.data?.status === 200) {
          setPatchUploadPopupVisible(false);
          setPatchUploadType(null);
          setPatchUploadFile(null);
          setUpdatePatchContentList(res?.data?.data);
          Widget.showMessage("success", res?.data?.message);
          document.getElementById("excelFile112").value = null;
        } else {
          setUpdatePatchContentList({});
        }
        setUpdatePatchContentListLoader(false);
      }));
  }

 
   return (
    <Context.Provider value={{
      ...props,
      mcqofthedayQuestion, setMcqofthedayQuestion,
      mcqofthedayQuestionLoader, setMcqofthedayQuestionLoader,
      fetchMcqofthedayQuestion,
      verticalUpdateLoader, setVerticalUpdateLoader,
      verticalGetLoader, setVerticalGetLoader,
      verticalForm,
      verticalSingleData, setVerticalSingleData,
      currentCats, setCurrentCats,
      fetchVertical,
      fetchVerticalUpdate,
      //version update
      fetchVerticalVersion,
      verticalVersionGetLoader, setVerticalVersionGetLoader,
      verticalVersionForm,
      verticalVersionSingleData, setVerticalVersionSingleData,
      fetchVerticalVersionUpdate,
      verticalVersionUpdateLoader, setVerticalVersionUpdateLoader,
      getPatchContentList, setGetPatchContentList,
      getPatchContentListLoader, setGetPatchContentListLoader,
      fetchPatchContent,
      patchUploadPopupVisible, setPatchUploadPopupVisible,
      patchUploadType, setPatchUploadType,
      patchUploadFile, setPatchUploadFile,
      updatePatchContent,
      updatePatchContentList, setUpdatePatchContentList,
      updatePatchContentListLoader, setUpdatePatchContentListLoader,
    }}>
      {props.children}
    </Context.Provider>
   ) 
};

export default DashboardProvider;

